import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import Header from './Header';
import AppRouter from './AppRouter';
import Footer from './Footer';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(<Header />, document.getElementById('header'));
ReactDOM.render(<AppRouter />, document.getElementById('content-wrap'));
ReactDOM.render(<Footer />, document.getElementById('footer'));

reportWebVitals();